import {
  PAYMENT_LIST_ACTION,
  GET_PAYMENT_ACTION,
  SETTLE_PAYMENT_ACTION,
  COMPANY_LIST_ACTION,
  GET_COMPANY_ACTION,
  EMPLOYEE_LIST_ACTION,
  GET_EMPLOYEE_ACTION,
  OVERVIEW_ACTION,
  INVITE_COMPANY_ACTION,
  UPDATE_COMPANY_ACTION,
  BULK_MONTHS_TO_SETTLE_ACTION,
  MONTHS_TO_SETTLE_ACTION,
  SETTLE_SALARY_ACTION,
  BULK_SETTLE_SALARY_ACTION,
  EXCHANGE_LIST_ACTION,
  GET_EXCHANGE_ACTION,
  CREATE_EXCHANGE_ACTION,
  UPDATE_EXCHANGE_ACTION,
  DELETE_EXCHANGE_ACTION,
  BACKOFFICE_DEDUCTION_LIST_ACTION,
  GET_DEDUCTION_ACTION,
  CREATE_DEDUCTION_ACTION,
  UPDATE_DEDUCTION_ACTION,
  DELETE_DEDUCTION_ACTION,
  OVERVIEW_FILTER_ACTION,
  TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION,
  TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION,
  TRANSACTION_HISTORY_ACTION,
  BACKOFFICE_COUNTRY_FEES_LIST_ACTION,
  CREATE_COUNTRY_FEES_ACTION,
  UPDATE_COUNTRY_FEES_ACTION, PAYMENT_DOWNLOAD_ACTION, PAYMENT_DOWNLOAD_RESET_ACTION, DASHBOARD_LOADING_ACTION,
  PAYMENT_SUB_TABLE_LIST_ACTION,
  DECLINE_PAYMENT_ACTION,
  GET_REPORTS_ACTION,
  PUSH_NOTIFICATION_ACTION,
  SEND_MONTHLY_COMPANY_REPORTS_ACTION,
  SEND_CUSTOM_COMPANY_REPORTS_ACTION,
  GET_PAYMENTS_COUNT_ACTION,
  UPDATE_COMPANY_PAYMENT_ACTION,
  DELETE_WITHDRAWAL_CATEGORY_ACTION,
  GET_WITHDRAWAL_CATEGORIES_ACTION,
  UPDATE_WITHDRAWAL_CATEGORY_ACTION,
  CREATE_WITHDRAWAL_CATEGORY_ACTION,
  GET_WITHDRAWAL_CATEGORY_ACTION,
  MERCHANT_LIST_ACTION,
  GET_MERCHANT_ACTION,
  INVITE_MERCHANT_ACTION,
  UPDATE_MERCHANT_ACTION,
  REACTIVATE_VENDOR_ACTION,
  SUSPEND_VENDOR_ACTION,
  PROMOTE_HR_TO_ADMIN_ACTION,
  GET_USER_ACTIVITY_LOGS_ACTION,
  GET_VENDOR_PAYMENTS_ACTION,
  GET_VENDOR_FEES_ACTION,
  CREATE_VENDOR_FEES_ACTION,
  UPDATE_VENDOR_FEES_ACTION,
  DELETE_VENDOR_FEES_ACTION,
  GET_COMPANY_FEES_ACTION,
  CREATE_COMPANY_FEES_ACTION,
  UPDATE_COMPANY_FEES_ACTION,
  DELETE_COMPANY_FEES_ACTION,
  GET_VENDOR_SETTLEMENTS_ACTION,
  ADD_VENDOR_BANK_DETAILS_ACTION,
  UPDATE_VENDOR_BANK_DETAILS_ACTION,
  DELETE_VENDOR_BANK_DETAILS_ACTION,
  GET_VENDOR_BANK_DETAILS_ACTION,
  LIST_VENDOR_BANK_DETAILS_ACTION,
  GET_PAYSTACK_BANKS_LIST_ACTION,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ACTION,
  VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR,
  ADD_VENDOR_BANK_DETAILS_ERROR,
  UPDATE_VENDOR_BANK_DETAILS_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_ACTION,
  VENDOR_RESEND_INVITATION_ACTION,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ACTION,
  ONBOARD_COMPANY_EMPLOYEES_ACTION,
  BONUS_LIST_ACTION,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_ERROR,
  GET_BONUS_ACTION,
  GET_BONUS_SUCCESS,
  GET_BONUS_ERROR,
  CREATE_BONUS_ACTION,
  CREATE_BONUS_SUCCESS,
  CREATE_BONUS_ERROR,
  UPDATE_BONUS_ACTION,
  UPDATE_BONUS_SUCCESS,
  UPDATE_BONUS_ERROR,
  DELETE_BONUS_ACTION,
  DELETE_BONUS_SUCCESS,
  DELETE_BONUS_ERROR,
  BONUS_CLAIM_LIST_ACTION,
  BONUS_CLAIM_LIST_SUCCESS,
  BONUS_CLAIM_LIST_ERROR,
  GET_BONUS_CLAIM_ACTION,
  GET_BONUS_CLAIM_SUCCESS,
  GET_BONUS_CLAIM_ERROR,
  DELETE_BONUS_CLAIM_ACTION,
  DELETE_BONUS_CLAIM_SUCCESS,
  DELETE_BONUS_CLAIM_ERROR,
  CAMPAIGN_CONFIG_REQUEST_ACTION,
  CAMPAIGN_LIST_REQUEST_ACTION,
  CAMPAIGN_DETAIL_REQUEST_ACTION,
  CAMPAIGN_CREATE_REQUEST_ACTION,
  CAMPAIGN_UPDATE_REQUEST_ACTION,
  CAMPAIGN_ACTION_REQUEST_ACTION,
  CAMPAIGN_STATS_REQUEST_ACTION,
  CAMPAIGN_HISTORY_REQUEST_ACTION,
  CAMPAIGN_SET_FILTERS_ACTION,
  CAMPAIGN_SET_PAGINATION_ACTION,
  CAMPAIGN_SET_HISTORY_PAGINATION_ACTION,
  CAMPAIGN_RESET_FORM_ERRORS_ACTION,
  CAMPAIGN_CLEAR_TOAST_ACTION,
  PERMISSION_CATALOGUE_ACTION,
  PERMISSION_CATALOGUE_SUCCESS,
  PERMISSION_CATALOGUE_ERROR,
  GROUP_LIST_ACTION,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_ERROR,
  GET_GROUP_ACTION,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  CREATE_GROUP_ACTION,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  UPDATE_GROUP_ACTION,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  DELETE_GROUP_ACTION,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  GROUP_MEMBER_LIST_ACTION,
  GROUP_MEMBER_LIST_SUCCESS,
  GROUP_MEMBER_LIST_ERROR,
  ADD_GROUP_MEMBERS_ACTION,
  ADD_GROUP_MEMBERS_SUCCESS,
  ADD_GROUP_MEMBERS_ERROR,
  REMOVE_GROUP_MEMBERS_ACTION,
  REMOVE_GROUP_MEMBERS_SUCCESS,
  REMOVE_GROUP_MEMBERS_ERROR,
  NOTIFICATION_COUNT_ACTION,
  NOTIFICATION_COUNT_SUCCESS,
  NOTIFICATION_COUNT_ERROR,
  NOTIFICATION_LIST_ACTION,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_ERROR,
  MARK_NOTIFICATION_READ_ACTION,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_ERROR,
  MARK_ALL_NOTIFICATIONS_READ_ACTION,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
  GET_FORTRESS_COMPANIES_ACTION,
  GET_FORTRESS_COMPANIES_SUCCESS,
  GET_FORTRESS_COMPANIES_ERROR,
  UPDATE_FORTRESS_COMPANIES_ACTION,
  UPDATE_FORTRESS_COMPANIES_SUCCESS,
  UPDATE_FORTRESS_COMPANIES_ERROR,
  FORTRESS_BANK_CODE_LIST_ACTION,
  FORTRESS_BANK_CODE_LIST_SUCCESS,
  FORTRESS_BANK_CODE_LIST_ERROR,
  UPDATE_FORTRESS_BANK_CODE_ACTION,
  UPDATE_FORTRESS_BANK_CODE_SUCCESS,
  UPDATE_FORTRESS_BANK_CODE_ERROR,
  DOWNLOAD_EMPLOYEE_STATEMENT_ACTION,
  DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS,
  DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
} from "./types";

export const onboardCompanyEmployeesAction = (data) => ({
  type: ONBOARD_COMPANY_EMPLOYEES_ACTION,
  payload: data
});

export const vendorSettlementAggregateAction = (data) => ({
  type: VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ACTION,
  payload: data
})

export const vendorResendInvitationAction = (data) => ({
  type: VENDOR_RESEND_INVITATION_ACTION,
  payload: data
});

export const deleteWithdrawalCategoryAction = (payload) => {
  return ({
    type: DELETE_WITHDRAWAL_CATEGORY_ACTION,
    payload: payload
  })
};

export const getWithdrawalCategoriesAction = (payload) => ({
  type: GET_WITHDRAWAL_CATEGORIES_ACTION,
  payload
});

export const getWithdrawalCategoryAction = (payload, category_id) => ({
  type: GET_WITHDRAWAL_CATEGORY_ACTION,
  payload
})

export const updateWithdrawalCategoryAction = (payload, category_id) => ({
  type: UPDATE_WITHDRAWAL_CATEGORY_ACTION,
  payload,
  category_id
});

export const createWithdrawalCategoryAction = (payload) => ({
  type: CREATE_WITHDRAWAL_CATEGORY_ACTION,
  payload
});

export const getPaymentListAction = (data) => ({
  type: PAYMENT_LIST_ACTION,
  payload: data,
});

// `params` is optional { start_time, end_time, month_day_range_type }.
// start_time/end_time are date-only (YYYY-MM-DD); month_day_range_type selects
// whether the report's day-range cycle spans month-to-month. Undefined values
// are dropped by toQuery, so omitting them downloads the full history.
export const getPaymentDownloadAction = (company_id, params = {}) => ({
  type: PAYMENT_DOWNLOAD_ACTION,
  company_id,
  start_time: params?.start_time,
  end_time: params?.end_time,
  month_day_range_type: params?.month_day_range_type,
});
export const resetPaymentDownloadAction = () => ({
  type: PAYMENT_DOWNLOAD_RESET_ACTION,
});

export const getPaymentInfoAction = (payment_id) => ({
  type: GET_PAYMENT_ACTION,
  payment_id: payment_id,
});

export const settlePaymentAction = (data, payment_id) => ({
  type: SETTLE_PAYMENT_ACTION,
  payload: data,
  payment_id: payment_id,
});

export const getBulkMonthsToSettleAction = (country) => ({
  type: BULK_MONTHS_TO_SETTLE_ACTION,
  country,
});

export const getMonthsToSettleAction = (employee_id) => ({
  type: MONTHS_TO_SETTLE_ACTION,
  employee_id,
});

export const settleSalaryAction = (employee_id, month = {}) => ({
  type: SETTLE_SALARY_ACTION,
  employee_id,
  month,
});

export const bulkSettleSalaryAction = (employees_ids, month) => ({
  type: BULK_SETTLE_SALARY_ACTION,
  employees_ids,
  month,
});

export const getCompanyListAction = (data) => ({
  type: COMPANY_LIST_ACTION,
  payload: data,
});

export const getPaymentWDListAction = (data) => ({
  type: PAYMENT_SUB_TABLE_LIST_ACTION,
  payload: data,
})

export const getCompanyInfoAction = (company_id) => ({
  type: GET_COMPANY_ACTION,
  company_id: company_id,
});

export const getEmployeeListAction = (data) => ({
  type: EMPLOYEE_LIST_ACTION,
  payload: data,
});

export const getEmployeeInfoAction = (employee_id) => ({
  type: GET_EMPLOYEE_ACTION,
  employee_id: employee_id,
});

export const getOverviewAction = (data) => ({
  type: OVERVIEW_ACTION,
  payload: data,
});

export const inviteCompanyAction = (data) => ({
  type: INVITE_COMPANY_ACTION,
  payload: data,
});

export const updateCompanyAction = (data) => ({
  type: UPDATE_COMPANY_ACTION,
  payload: data,
});

export const getExchangeListAction = (data) => ({
  type: EXCHANGE_LIST_ACTION,
  payload: data,
});

export const getExchangeInfoAction = (exchange_id) => ({
  type: GET_EXCHANGE_ACTION,
  exchange_id: exchange_id,
});

export const createExchangeAction = (data) => ({
  type: CREATE_EXCHANGE_ACTION,
  payload: data,
});

export const updateExchangeAction = (data, exchange_id) => ({
  type: UPDATE_EXCHANGE_ACTION,
  payload: data,
  exchange_id: exchange_id,
});

export const deleteExchangeAction = (exchange_id) => ({
  type: DELETE_EXCHANGE_ACTION,
  exchange_id: exchange_id,
});

export const getDeductionListAction = (data) => ({
  type: BACKOFFICE_DEDUCTION_LIST_ACTION,
  payload: data,
});

export const getDeductionInfoAction = (deduction_id) => ({
  type: GET_DEDUCTION_ACTION,
  deduction_id: deduction_id,
});

export const createDeductionAction = (data) => ({
  type: CREATE_DEDUCTION_ACTION,
  payload: data,
});

export const updateDeductionAction = (data, deduction_id) => ({
  type: UPDATE_DEDUCTION_ACTION,
  payload: data,
  deduction_id: deduction_id,
});

export const deleteDeductionAction = (deduction_id) => ({
  type: DELETE_DEDUCTION_ACTION,
  deduction_id: deduction_id,
});

/* -------------------------------- Bonuses -------------------------------- */
// List bonuses. data: { category, is_active, page, page_size }
export const getBonusListAction = (data) => ({
  type: BONUS_LIST_ACTION,
  payload: data,
});
export const getBonusListSuccessAction = (data) => ({
  type: BONUS_LIST_SUCCESS,
  payload: data,
});
export const getBonusListErrorAction = (error) => ({
  type: BONUS_LIST_ERROR,
  payload: error,
});

export const getBonusInfoAction = (bonus_id) => ({
  type: GET_BONUS_ACTION,
  bonus_id: bonus_id,
});
export const getBonusInfoSuccessAction = (data) => ({
  type: GET_BONUS_SUCCESS,
  payload: data,
});
export const getBonusInfoErrorAction = (error) => ({
  type: GET_BONUS_ERROR,
  payload: error,
});

export const createBonusAction = (data) => ({
  type: CREATE_BONUS_ACTION,
  payload: data,
});
export const createBonusSuccessAction = (data) => ({
  type: CREATE_BONUS_SUCCESS,
  payload: data,
});
// fieldErrors: optional details map ({ field: [errors] }) for inline form errors.
export const createBonusErrorAction = (error, fieldErrors = null) => ({
  type: CREATE_BONUS_ERROR,
  payload: error,
  fieldErrors,
});

export const updateBonusAction = (data, bonus_id) => ({
  type: UPDATE_BONUS_ACTION,
  payload: data,
  bonus_id: bonus_id,
});
export const updateBonusSuccessAction = (data) => ({
  type: UPDATE_BONUS_SUCCESS,
  payload: data,
});
export const updateBonusErrorAction = (error, fieldErrors = null) => ({
  type: UPDATE_BONUS_ERROR,
  payload: error,
  fieldErrors,
});

export const deleteBonusAction = (bonus_id) => ({
  type: DELETE_BONUS_ACTION,
  bonus_id: bonus_id,
});
export const deleteBonusSuccessAction = (data) => ({
  type: DELETE_BONUS_SUCCESS,
  payload: data,
});
export const deleteBonusErrorAction = (error) => ({
  type: DELETE_BONUS_ERROR,
  payload: error,
});

/* --------------------------------- Claims -------------------------------- */
// List claims. data: { bonus, employee, state, page, page_size }
export const getBonusClaimListAction = (data) => ({
  type: BONUS_CLAIM_LIST_ACTION,
  payload: data,
});
export const getBonusClaimListSuccessAction = (data) => ({
  type: BONUS_CLAIM_LIST_SUCCESS,
  payload: data,
});
export const getBonusClaimListErrorAction = (error) => ({
  type: BONUS_CLAIM_LIST_ERROR,
  payload: error,
});

export const getBonusClaimInfoAction = (claim_id) => ({
  type: GET_BONUS_CLAIM_ACTION,
  claim_id: claim_id,
});
export const getBonusClaimInfoSuccessAction = (data) => ({
  type: GET_BONUS_CLAIM_SUCCESS,
  payload: data,
});
export const getBonusClaimInfoErrorAction = (error) => ({
  type: GET_BONUS_CLAIM_ERROR,
  payload: error,
});

export const deleteBonusClaimAction = (claim_id) => ({
  type: DELETE_BONUS_CLAIM_ACTION,
  claim_id: claim_id,
});
export const deleteBonusClaimSuccessAction = (data) => ({
  type: DELETE_BONUS_CLAIM_SUCCESS,
  payload: data,
});
export const deleteBonusClaimErrorAction = (error) => ({
  type: DELETE_BONUS_CLAIM_ERROR,
  payload: error,
});

/* ----------------------------- Role Groups ----------------------------- */
// Permission catalogue (plain array).
export const getPermissionCatalogueAction = () => ({
  type: PERMISSION_CATALOGUE_ACTION,
});
export const getPermissionCatalogueSuccessAction = (data) => ({
  type: PERMISSION_CATALOGUE_SUCCESS,
  payload: data,
});
export const getPermissionCatalogueErrorAction = (error) => ({
  type: PERMISSION_CATALOGUE_ERROR,
  payload: error,
});

// Groups list. data: { search, page, page_size }
export const getGroupListAction = (data) => ({
  type: GROUP_LIST_ACTION,
  payload: data,
});
export const getGroupListSuccessAction = (data) => ({
  type: GROUP_LIST_SUCCESS,
  payload: data,
});
export const getGroupListErrorAction = (error) => ({
  type: GROUP_LIST_ERROR,
  payload: error,
});

export const getGroupAction = (group_id) => ({
  type: GET_GROUP_ACTION,
  group_id,
});
export const getGroupSuccessAction = (data) => ({
  type: GET_GROUP_SUCCESS,
  payload: data,
});
export const getGroupErrorAction = (error) => ({
  type: GET_GROUP_ERROR,
  payload: error,
});

export const createGroupAction = (data) => ({
  type: CREATE_GROUP_ACTION,
  payload: data,
});
export const createGroupSuccessAction = (data) => ({
  type: CREATE_GROUP_SUCCESS,
  payload: data,
});
// fieldErrors: optional { field: [msg] } map for inline form errors.
export const createGroupErrorAction = (error, fieldErrors = null) => ({
  type: CREATE_GROUP_ERROR,
  payload: error,
  fieldErrors,
});

export const updateGroupAction = (data, group_id) => ({
  type: UPDATE_GROUP_ACTION,
  payload: data,
  group_id,
});
export const updateGroupSuccessAction = (data) => ({
  type: UPDATE_GROUP_SUCCESS,
  payload: data,
});
export const updateGroupErrorAction = (error, fieldErrors = null) => ({
  type: UPDATE_GROUP_ERROR,
  payload: error,
  fieldErrors,
});

export const deleteGroupAction = (group_id) => ({
  type: DELETE_GROUP_ACTION,
  group_id,
});
export const deleteGroupSuccessAction = (data) => ({
  type: DELETE_GROUP_SUCCESS,
  payload: data,
});
export const deleteGroupErrorAction = (error) => ({
  type: DELETE_GROUP_ERROR,
  payload: error,
});

// Members list (paginated). data: { page, page_size }
export const getGroupMembersAction = (data, group_id) => ({
  type: GROUP_MEMBER_LIST_ACTION,
  payload: data,
  group_id,
});
export const getGroupMembersSuccessAction = (data) => ({
  type: GROUP_MEMBER_LIST_SUCCESS,
  payload: data,
});
export const getGroupMembersErrorAction = (error) => ({
  type: GROUP_MEMBER_LIST_ERROR,
  payload: error,
});

// Add members. data: { user_ids: [...] } -> success payload is the full member array.
export const addGroupMembersAction = (data, group_id) => ({
  type: ADD_GROUP_MEMBERS_ACTION,
  payload: data,
  group_id,
});
export const addGroupMembersSuccessAction = (data) => ({
  type: ADD_GROUP_MEMBERS_SUCCESS,
  payload: data,
});
export const addGroupMembersErrorAction = (error) => ({
  type: ADD_GROUP_MEMBERS_ERROR,
  payload: error,
});

// Remove members. data: { user_ids: [...] } -> success payload is the full member array.
export const removeGroupMembersAction = (data, group_id) => ({
  type: REMOVE_GROUP_MEMBERS_ACTION,
  payload: data,
  group_id,
});
export const removeGroupMembersSuccessAction = (data) => ({
  type: REMOVE_GROUP_MEMBERS_SUCCESS,
  payload: data,
});
export const removeGroupMembersErrorAction = (error) => ({
  type: REMOVE_GROUP_MEMBERS_ERROR,
  payload: error,
});

/* ------------------------- Notifications ------------------------------- */
// Badge count { unread, total }.
export const getNotificationCountAction = () => ({
  type: NOTIFICATION_COUNT_ACTION,
});
export const getNotificationCountSuccessAction = (data) => ({
  type: NOTIFICATION_COUNT_SUCCESS,
  payload: data,
});
export const getNotificationCountErrorAction = (error) => ({
  type: NOTIFICATION_COUNT_ERROR,
  payload: error,
});

// List (paginated). data: { is_read, intent, page, page_size }
// append=true concatenates the page onto the existing feed (infinite scroll);
// append=false (default) replaces it (fresh open / filter change).
export const getNotificationsAction = (data, append = false) => ({
  type: NOTIFICATION_LIST_ACTION,
  payload: data,
  append,
});
export const getNotificationsSuccessAction = (data) => ({
  type: NOTIFICATION_LIST_SUCCESS,
  payload: data,
});
export const getNotificationsErrorAction = (error) => ({
  type: NOTIFICATION_LIST_ERROR,
  payload: error,
});

// Mark one read — returns the updated notification (patched in place).
export const markNotificationReadAction = (notification_id) => ({
  type: MARK_NOTIFICATION_READ_ACTION,
  notification_id,
});
export const markNotificationReadSuccessAction = (data) => ({
  type: MARK_NOTIFICATION_READ_SUCCESS,
  payload: data,
});
export const markNotificationReadErrorAction = (error) => ({
  type: MARK_NOTIFICATION_READ_ERROR,
  payload: error,
});

// Mark all read.
export const markAllNotificationsReadAction = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ_ACTION,
});
export const markAllNotificationsReadSuccessAction = (data) => ({
  type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  payload: data,
});
export const markAllNotificationsReadErrorAction = (error) => ({
  type: MARK_ALL_NOTIFICATIONS_READ_ERROR,
  payload: error,
});

export const setOverviewFilters = (data) => ({
  type: OVERVIEW_FILTER_ACTION,
  payload: data,
});

export const setWithdrawalRequestsFilters = (data) => ({
  type: TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION,
  payload: data,
});

export const setOvertimeRequestsFilters = (data) => ({
  type: TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION,
  payload: data,
});

export const setDashboardLoading = (data) => ({
  type: DASHBOARD_LOADING_ACTION,
  payload: data
});

export const getTransactionHistoryAction = (data) => ({
  type: TRANSACTION_HISTORY_ACTION,
  payload: data,
});

export const getCountriesFeesListAction = (data) => ({
  type: BACKOFFICE_COUNTRY_FEES_LIST_ACTION,
  payload: data,
});

export const createCountryFeesAction = (data) => ({
  type: CREATE_COUNTRY_FEES_ACTION,
  payload: data,
});

export const updateCountryFeesAction = (data) => ({
  type: UPDATE_COUNTRY_FEES_ACTION,
  payload: data,
});

export const declinePaymentAction = (data, payment_id) => ({
  type: DECLINE_PAYMENT_ACTION,
  payload: data,
  payment_id: payment_id
});

export const getReportsAction = (reportsType, data) => ({
  type: GET_REPORTS_ACTION,
  payload: data,
  reportsType: reportsType
});

export const pushNotificationAction = (data) => ({
  type: PUSH_NOTIFICATION_ACTION,
  payload: data
});

export const sendMonthlyCompanyReportsAction = (data) => ({
  type: SEND_MONTHLY_COMPANY_REPORTS_ACTION,
  payload: data
});

export const sendCustomCompanyReportsAction = (data) => ({
  type: SEND_CUSTOM_COMPANY_REPORTS_ACTION,
  payload: data
});

export const getPaymentsCountAction = (data) => ({
  type: GET_PAYMENTS_COUNT_ACTION,
  payload: data
});

export const updateCompanyPaymentAction = (data, payment_id) => ({
  type: UPDATE_COMPANY_PAYMENT_ACTION,
  payload: data,
  payment_id: payment_id
});

export const getMerchantListAction = (data) => ({
  type: MERCHANT_LIST_ACTION,
  payload: data,
});

export const getMerchantInfoAction = (merchant_id) => ({
  type: GET_MERCHANT_ACTION,
  merchant_id: merchant_id,
});

export const inviteMerchantAction = (data) => ({
  type: INVITE_MERCHANT_ACTION,
  payload: data,
});

export const updateMerchantAction = (data, merchant_id) => ({
  type: UPDATE_MERCHANT_ACTION,
  payload: data,
  merchant_id: merchant_id,
});

export const reactivateVendorAction = (vendor_id) => ({
  type: REACTIVATE_VENDOR_ACTION,
  vendor_id: vendor_id,
});

export const suspendVendorAction = (vendor_id) => ({
  type: SUSPEND_VENDOR_ACTION,
  vendor_id: vendor_id,
});
export const promoteHrToAdminAction = (data) => ({
  type: PROMOTE_HR_TO_ADMIN_ACTION,
  payload: data
});

export const getUserActivityLogsAction = (data) => ({
  type: GET_USER_ACTIVITY_LOGS_ACTION,
  payload: data
});

export const getVendorPaymentsAction = (vendor_id, data) => ({
  type: GET_VENDOR_PAYMENTS_ACTION,
  vendor_id: vendor_id,
  payload: data,
});

export const getVendorFeesAction = (data) => ({
  type: GET_VENDOR_FEES_ACTION,
  payload: data,
});

export const createVendorFeesAction = (data) => ({
  type: CREATE_VENDOR_FEES_ACTION,
  payload: data,
});

export const updateVendorFeesAction = (data) => ({
  type: UPDATE_VENDOR_FEES_ACTION,
  payload: data,
});

export const deleteVendorFeesAction = (fee_range_id) => ({
  type: DELETE_VENDOR_FEES_ACTION,
  fee_range_id: fee_range_id,
});

export const getCompanyFeesAction = (data) => ({
  type: GET_COMPANY_FEES_ACTION,
  payload: data,
});

export const createCompanyFeesAction = (data) => ({
  type: CREATE_COMPANY_FEES_ACTION,
  payload: data,
});

export const updateCompanyFeesAction = (data) => ({
  type: UPDATE_COMPANY_FEES_ACTION,
  payload: data,
});

export const deleteCompanyFeesAction = (fee_range_id) => ({
  type: DELETE_COMPANY_FEES_ACTION,
  fee_range_id: fee_range_id,
});

export const getVendorSettlementsAction = (data) => ({
  type: GET_VENDOR_SETTLEMENTS_ACTION,
  payload: data,
});

export const addVendorBankDetailsAction = (data) => ({
  type: ADD_VENDOR_BANK_DETAILS_ACTION,
  payload: data,
});

export const updateVendorBankDetailsAction = (data) => ({
  type: UPDATE_VENDOR_BANK_DETAILS_ACTION,
  payload: data,
});

export const deleteVendorBankDetailsAction = (data) => ({
  type: DELETE_VENDOR_BANK_DETAILS_ACTION,
  payload: data,
});

export const getVendorBankDetailsAction = (data) => ({
  type: GET_VENDOR_BANK_DETAILS_ACTION,
  payload: data,
});

export const listVendorBankDetailsAction = (data) => ({
  type: LIST_VENDOR_BANK_DETAILS_ACTION,
  payload: data,
});
export const getPaystackBanksListAction = (data) => ({
  type: GET_PAYSTACK_BANKS_LIST_ACTION,
  payload: data,
});

export const verifyPaystackBankAccountAction = (data) => ({
  type: VERIFY_PAYSTACK_BANK_ACCOUNT_ACTION,
  payload: data,
});

export const verifyPaystackBankAccountErrorResetAction = () => ({
  type: VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR,
  payload: null
});

export const verifyPaystackBankAccountResetAction = () => ({
  type: VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS,
  payload: null,
});

export const addVendorBankDetailsErrorAction = (error) => ({
  type: ADD_VENDOR_BANK_DETAILS_ERROR,
  payload: error,
});

export const updateVendorBankDetailsErrorAction = (error) => ({
  type: UPDATE_VENDOR_BANK_DETAILS_ERROR,
  payload: error,
});

export const vendorSettlementTriggerAction = (data) => ({
  type: VENDOR_SETTLEMENT_TRIGGER_ACTION,
  payload: data
})

export const getCampaignConfigAction = (callbacks = {}) => ({
  type: CAMPAIGN_CONFIG_REQUEST_ACTION,
  ...callbacks,
});

export const getCampaignListAction = (payload = {}, callbacks = {}) => ({
  type: CAMPAIGN_LIST_REQUEST_ACTION,
  payload,
  ...callbacks,
});

export const getCampaignDetailAction = (campaignId, callbacks = {}) => ({
  type: CAMPAIGN_DETAIL_REQUEST_ACTION,
  campaignId,
  ...callbacks,
});

export const createCampaignAction = (payload, callbacks = {}) => ({
  type: CAMPAIGN_CREATE_REQUEST_ACTION,
  payload,
  ...callbacks,
});

export const updateCampaignAction = (campaignId, payload, callbacks = {}) => ({
  type: CAMPAIGN_UPDATE_REQUEST_ACTION,
  campaignId,
  payload,
  ...callbacks,
});

export const campaignWorkflowAction = (campaignId, workflowAction, payload = {}, callbacks = {}) => ({
  type: CAMPAIGN_ACTION_REQUEST_ACTION,
  campaignId,
  workflowAction,
  payload,
  ...callbacks,
});

export const getCampaignStatsAction = (campaignId, callbacks = {}) => ({
  type: CAMPAIGN_STATS_REQUEST_ACTION,
  campaignId,
  ...callbacks,
});

export const getCampaignHistoryAction = (campaignId, payload = {}, callbacks = {}) => ({
  type: CAMPAIGN_HISTORY_REQUEST_ACTION,
  campaignId,
  payload,
  ...callbacks,
});

export const setCampaignFiltersAction = (payload = {}) => ({
  type: CAMPAIGN_SET_FILTERS_ACTION,
  payload,
});

export const setCampaignPaginationAction = (payload = {}) => ({
  type: CAMPAIGN_SET_PAGINATION_ACTION,
  payload,
});

export const setCampaignHistoryPaginationAction = (payload = {}) => ({
  type: CAMPAIGN_SET_HISTORY_PAGINATION_ACTION,
  payload,
});

export const resetCampaignFormErrorsAction = () => ({
  type: CAMPAIGN_RESET_FORM_ERRORS_ACTION,
});

export const clearCampaignToastAction = () => ({
  type: CAMPAIGN_CLEAR_TOAST_ACTION,
});

/* ── Payment-gateway config (Fortress) — super-only ─────────────────────── */

export const getFortressCompaniesAction = () => ({
  type: GET_FORTRESS_COMPANIES_ACTION,
});

export const getFortressCompaniesSuccessAction = (payload) => ({
  type: GET_FORTRESS_COMPANIES_SUCCESS,
  payload,
});

export const getFortressCompaniesErrorAction = (payload) => ({
  type: GET_FORTRESS_COMPANIES_ERROR,
  payload,
});

// data: { companies: ["<uuid>", ...] } — whole-list replace (empty = all Paystack).
export const updateFortressCompaniesAction = (data) => ({
  type: UPDATE_FORTRESS_COMPANIES_ACTION,
  payload: data,
});

export const updateFortressCompaniesSuccessAction = (payload) => ({
  type: UPDATE_FORTRESS_COMPANIES_SUCCESS,
  payload,
});

export const updateFortressCompaniesErrorAction = (payload) => ({
  type: UPDATE_FORTRESS_COMPANIES_ERROR,
  payload,
});

// data: { bank_name?, bank_code?, institution_code?, search?, page, page_size, history? }
export const getFortressBankCodesAction = (data) => ({
  type: FORTRESS_BANK_CODE_LIST_ACTION,
  payload: data,
});

export const getFortressBankCodesSuccessAction = (payload) => ({
  type: FORTRESS_BANK_CODE_LIST_SUCCESS,
  payload,
});

export const getFortressBankCodesErrorAction = (payload) => ({
  type: FORTRESS_BANK_CODE_LIST_ERROR,
  payload,
});

// For now only bank_code is editable — data: { bank_code }.
export const updateFortressBankCodeAction = (data, id) => ({
  type: UPDATE_FORTRESS_BANK_CODE_ACTION,
  payload: data,
  id,
});

export const updateFortressBankCodeSuccessAction = (payload) => ({
  type: UPDATE_FORTRESS_BANK_CODE_SUCCESS,
  payload,
});

export const updateFortressBankCodeErrorAction = (payload, fieldErrors = null) => ({
  type: UPDATE_FORTRESS_BANK_CODE_ERROR,
  payload,
  fieldErrors,
});
export const downloadEmployeeStatementAction = ({ employeeId, start_time, end_time }) => ({
  type: DOWNLOAD_EMPLOYEE_STATEMENT_ACTION,
  payload: { employeeId, start_time, end_time },
});

export const downloadEmployeeStatementSuccessAction = (payload) => ({
  type: DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS,
  payload,
});

export const downloadEmployeeStatementErrorAction = (payload) => ({
  type: DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
  payload,
});
